import Api from 'api';
import React from "react";
import Modal from './Modal';
import Header from './Header';
import MainBody from './Body';
import ItemList from './Items';
import Reviews from './Reviews';
import Emptystate from './Placeholder';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Navigation, Footer } from 'components';
import { actions, selectors } from 'redux-store';

class ProductDetails extends React.Component {

  constructor(props) {

    super(props);

    this.api = new Api();

    this.root = React.createRef();

    this.location = this.props.location.pathname;

    this.state = {

      show_modal: false,

      product: {
        tags: '',
        title: 'Products',
        attributes: [],
        description: '',
        pricing: {}
      },

      related_products: []

    };

  }

  componentDidMount =  () => {

    //if (!this.reload(handle)) return this.update_state(current_product);

    return this.load_product_details(this.props);

  }

  componentWillReceiveProps = (props) => {

    const { product } = this.state;

    const { handle } = props.match.params;

    if (product.handle === handle) return;

    return this.check_current_url(props);

  }

  check_current_url = (props) => {

    const { handle } = props.match.params;

    const { current_product } = this.props;

    const refresh = (current_product.handle !== handle);

    if (!current_product.handle) return this.load_product_details(props);

    if (!!refresh) return window.location.reload();

    return this.load_product_details(props);

  }

  load_product_details = async (props) => {

    const { handle } = props.match.params;

    await this.fetch_redux_products(handle);

    return this.related_products();

  }

  fetch_redux_products = async (handle) => {

    const { product_list = [] } = this.props;

    if (product_list.empty()) return this.fetch_api_products(handle);

    const current_product = product_list.filter(a => a.handle===handle)[0];

    return this.update_state(current_product);

  }

  fetch_api_products = async (handle) => {

    const { empty, docs } = await this.api.fetch('products','handle',handle);

    return (!!empty) ? null : this.update_state(docs[0].data());

  }

  add_to_cart = async () => {

    const { product } = this.state;

    const payload = { ...product, quantity: 1 };

    await this.props.add_product_to_cart(payload);

    return this.setState({ show_modal: true });

  }

  update_state = (new_product) => {

    if (!new_product) return null;

    const { handle } = this.state.product;

    if (handle===new_product.handle) return;

    this.props.set_current_product(new_product);

    return this.setState({ product: new_product });

  }

  related_products = async () => {

    const { category = '' } = this.state.product;

    const { docs = [] } = await this.api.fetch('products','category',category);

    const product_list = docs.map(a => ({ ...a.data(), id: a.id }));

    return this.setState({ related_products: product_list });

  }

  render() {

    const { product, related_products } = this.state;

    if (!product.handle) return (<Emptystate/>);

    return (
      <section className='Product-Details' ref={this.root}>

        <Helmet title={`${product.title} | Adenzo Comfies`} />

        <Navigation/>

        <Header
          product={this.state.product}
          addToCart={this.add_to_cart}
        />

        <MainBody
          product={product}
        />

        <ItemList
          data={related_products}
          caption='Frequently Bought Together'
        />

        <Reviews/>

        <Footer/>

        <Modal
          cart={this.props.cart}
          count={this.props.cart_count}
          total={this.props.cart_total}
          hidden={!this.state.show_modal}
          handle={this.state.product.handle}
          close={() => this.setState({ show_modal: false })}
        />

      </section>
    );
  }
}

const mapStateToProps = ({ cache, cart }) => ({
  ...cache,
  cart: cart.cart_items,
  cart_count: selectors.cart_count(cart),
  cart_total: selectors.cart_total(cart),
  _items: selectors.get_items_by_id(cache.product_list,1,10)
});

export default connect(mapStateToProps,{...actions})(ProductDetails);
